import { TAutomationApp } from "../../types";

export type TWeatherForecast = {
  latitude: number;
  longitude: number;
  units: string;
  tempNextDayMax: number;
  tempNextDayMin: number;
  temp: number
  forecast: string;
} & TAutomationApp

export const schema = 'AutomationApps.Utils.WeatherForecasts.WeatherForecast';

export type TForecast = {
  hourly: THourlyForecastEntry[],
  current: TCurrentForecastEntry
}
export type THourlyForecastEntry = {
  dt: number,
  temp: number,
  humidity: number,
  pressure: number,
  windSpeed: number,
  windGust: number,
  cloudiness: number,
  iconUrl: string
}

export type TCurrentForecastEntry = {
  sunrise: number,
  sunset: number,
} & THourlyForecastEntry